import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Colors from 'pubweb-smokey/dist/colors';
import Button from '@components/Shared/Buttons/Button';

import {
  scrollLock,
  scrollUnlock,
  scrollLocked,
} from 'pubweb-smokey/dist/utils/utils';
import { AnchoredModalStyles } from './AnchoredModal.styled';

const AnchoredModal = ({
  children,
  onCloseClick,
  showClearButton = true,
  onClearButtonClick,
  showApplyButton = true,
  onApplyButtonClick,
  showPageOverlay = true,
  automationId,
  pageOverlayVerticalOffsetInPixels,
  showOverflow = false,
  autoPosition = false,
  clearButtonClassName = '',
  applyButtonClassName = '',
}) => {
  useEffect(() => {
    if (!scrollLocked()) {
      scrollLock();

      return () => {
        scrollUnlock();
      };
    }
  });

  return (
    <AnchoredModalStyles
      className={autoPosition ? 'auto-position' : ''}
      pageOverlayOffset={pageOverlayVerticalOffsetInPixels}
      showOverflow={showOverflow}
    >
      {showPageOverlay && (
        <div className="page-overlay" onPointerDown={onCloseClick}></div>
      )}

      <div className="modal-window">
        <div className="anchored-modal-content">{children}</div>

        <div className="bottom-controls">
          <div>
            {showClearButton && (
              <Button
                className={clearButtonClassName}
                isCompact={true}
                primaryColor={Colors.primary.black}
                onDarkBg={true}
                automationId={automationId + '-clear-button'}
                onButtonClick={onClearButtonClick}
              >
                Clear
              </Button>
            )}
          </div>

          <div>
            {showApplyButton && (
              <Button
                className={applyButtonClassName}
                isCompact={true}
                automationId={automationId + '-apply-button'}
                onButtonClick={onApplyButtonClick}
              >
                Apply
              </Button>
            )}
          </div>
        </div>
      </div>
    </AnchoredModalStyles>
  );
};

AnchoredModal.propTypes = {
  applyButtonClassName: PropTypes.string,
  autoPosition: PropTypes.bool,
  automationId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  clearButtonClassName: PropTypes.string,
  onApplyButtonClick: PropTypes.any,
  onClearButtonClick: PropTypes.any,
  onCloseClick: PropTypes.any,
  pageOverlayVerticalOffsetInPixels: PropTypes.any,
  showApplyButton: PropTypes.bool,
  showClearButton: PropTypes.bool,
  showOverflow: PropTypes.bool,
  showPageOverlay: PropTypes.bool,
};

export default AnchoredModal;
